import type { ClassValue } from 'clsx';
import classnames from 'clsx';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { Icon } from '..';

import { TXTWCL_RatingX_N0_out_of_N1_stars } from './StarRating.messages.json';
import styles from './StarRating.scss';

interface Props {
  rating: number;
  size: 'xs' | 'sm' | 'lg' | 'xl' | 'x1' | 'x2' | 'x2.5' | 'x3' | 'x4' | 'x5';
  isInverted?: boolean;
  className?: ClassValue;
}

const StarRating: React.FC<Props> = ({ rating, size, isInverted = false, className }) => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <div
      className={classnames(styles.container, className)}
      role="img"
      aria-label={formatMessage(TXTWCL_RatingX_N0_out_of_N1_stars, {
        0: rating,
        1: 5
      })}
    >
      {Array.from({ length: 5 }, (_, i) => (
        <Icon
          name={i < rating ? 'star' : 'star-empty'}
          size={size}
          key={`star-${i}`}
          className={classnames(styles.star, {
            [styles.inverted]: isInverted
          })}
        />
      ))}
    </div>
  );
};

export { StarRating };
